<template>
  <div v-on:scroll="onScroll" class="home general">
    <h1 class="section-title">
      Lista de Artistas
      <va-button
        color="info"
        @click="createArtist()"
      >
        Crear Artista
      </va-button>
    </h1>

    <va-data-table
        class="ekitable"
        :items="artists"
        :columns="columns"
        clickable
        no-data-html="<div class='no-data'>Cargando pistas...</div>"
        :sticky-header="true"
        :loading="false"
        loading-text=""
    >
      <template #headerPrepend>
        <tr>
          <th colspan="6">
            <va-input class="search-bar" title="Buscar Canciones" v-title placeholder="¿Qué canción buscas?" v-on:keyup.enter="onEnter" v-on:focusout="onEnter" v-model="search">
              <template #prependInner>
                <font-awesome-icon :icon="['fa-solid', 'search']" />
              </template>
            </va-input>
          </th>
        </tr>
      </template>

      <template #header(name)="{ label }">
        <div class="label ekiflex flex-vcenter flex-hbetween" title="Ordenar por Título" v-title @click="sortList('name')">
          <div>
            {{ label }}
          </div>
          <font-awesome-icon :icon="['fa-solid', getIcon('name')]" size="1x"/>
        </div>
      </template>

      <template #cell(image)="{ rowData, rowIndex }">
        <va-avatar class="border-square"
                  size="small"
                  :src="rowData.image"/>
      </template>

      <template #cell(name)="{ rowData }">
        <router-link
          v-if="rowData.id"
          title="Ir al Detalle del Artista" v-title
          :to="{ name: 'artistDetail', params: { id: rowData.id } }"
          class="song-title linked"
        >{{ rowData.name }}</router-link>
        <div v-else class="song-title">{{ rowData.name }}</div>
      </template>

      <template #cell(active)="{ row, isExpanded, rowIndex }">
        <div class="actions">
          <va-switch
            v-model="artists[rowIndex].active"
            @update:modelValue="saveArtist(rowIndex)"
            title="Cambiar estado" 
            v-title color="success"
            class="action"
          />
          <va-button
            color="#ffffff"
            class="action"
            title="Editar género" 
            v-title
            @click="row.toggleRowDetails()"
            :icon="isExpanded ? 'va-arrow-up': 'va-arrow-down'"
            preset="secondary"
          >
            Editar
          </va-button>
        </div>        
      </template>

      <template #expandableRow="{ rowData }">
        <div class="edit-container">
          <div class="config">
            <div class="title">Edición</div>
            <va-input
              v-model="artists[findIndex(rowData.id ?? rowData.localId)].name"
              class="input"
              label="Nombre"
              title="Cambiar nombre" 
              v-title
              placeholder="Nombre"
            />
            <va-input
              v-model="artists[findIndex(rowData.id ?? rowData.localId)].description"
              class="input"
              type="textarea"
              label="Descripción"
              title="Cambiar descipción" 
              v-title
              placeholder="Descripción"
            />
            
            <div class="field c-1-3">
              <span class="va-title">Foto</span>
              <va-file-upload
                dropzone
                type="single"
                file-types="image/*"
                v-model:model-value="newImg"
                @file-added="checkFile(findIndex(rowData.id ?? rowData.localId))"
                @file-removed="checkFile(findIndex(rowData.id ?? rowData.localId))"
                hideFileList
              >
              <div class="upload-area">
                <div class="hover-info">
                  Cambiar imagen
                </div>
                <img
                  :src="rowData.image"
                  width="100"
                  height="100"
                >
              </div>
              </va-file-upload>
            </div>
            <div class="field c-1-3">
              <span class="va-title">Rating</span>
              <va-counter
                :min="0"
                :max="100"
                :step="1"
                v-model="artists[findIndex(rowData.id ?? rowData.localId)].rate"
                manual-input
                class="input"
                title="Cambiar rating" 
                v-title
              />   
            </div>            
            <div class="field c-1-3">
              <span class="va-title">¿Activo?</span>
              <va-switch
                v-model="artists[findIndex(rowData.id ?? rowData.localId)].active"
                title="Cambiar estado" 
                v-title color="success"
                class="input"
              />
            </div>
            
            <va-button
              color="warning"
              class="btn"
              @click="saveArtist(findIndex(rowData.id ?? rowData.localId))"
            >
              Guardar
            </va-button>
            <va-button
              color="danger"
              class="btn"
              v-if="rowData.id"
              @click="deleteArtist(findIndex(rowData.id))"
            >
              Eliminar
            </va-button>
          </div>
          <div class="preview">
            <div class="title">Vista Previa</div>
            <div class="app-bg ekiflex flex-hcenter">
              <div title="Ir al detalle del Artista" v-title class="artist-card ekiflex flex-vcenter flex-hcenter">
                <div class="artist-thumb">
                  <img :lazy-src="require('@/assets/background.png')"
                        :src="rowData.image"
                      />
                </div>
                <p class="artist-title">{{ rowData.name }}</p>
                <span class="artist-extra">n canciones</span>
              </div>
            </div>            
          </div>
        </div>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import requester from '../../services/requester';
export default {
  name: 'ArtistsList',

  data() {
    return {
      search: "",
      artistsPage: 1,
      artists: [],
      columns: [
        {key: 'image', sortable: false, label: ' ', width: '35px'},
        {key: 'name', sortable: false, label: 'Título'},
        {key: 'rate', sortable: false, label: 'Rating'},
        {key: 'active', sortable: false, label: 'Activo'},
      ],
      isLoading: false,
      sortings: new Map(),
      sortingOrder: null,
      sortBy: null,
      continueLoading: true,
      localId: 0,
      newImg: []
    };
  },

  methods: {
    onEnter(){
      this.artistsPage = 1;
      this.getArtistsFromAPI();
    },

    getIcon(sortBy){
      const sortingOrder = this.sortings.get(sortBy);
      return !sortingOrder?'sort':sortingOrder==='ASC'?'sort-up':'sort-down';
    },

    setSorting({sortBy, sortingOrder}){
      if(this.sortBy === sortBy && this.sortingOrder === sortingOrder) {
        return;
      }
      this.sortBy = sortBy;
      this.sortingOrder = sortingOrder;
      this.onEnter();
    },

    sortList(sortBy){
      const sortingOrder = this.sortings.get(sortBy) === 'ASC'?'DESC':'ASC';
      this.sortings.set(sortBy,sortingOrder)
      this.setSorting({sortBy, sortingOrder})
    },

    onScroll(event) {
      if(!this.continueLoading){
        return;
      }
      if (!this.isLoading) {
        const {target} = event;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
          this.getArtistsFromAPI(true);
        }
      }
    },

    getArtists(){
      try {
        this.getArtistsFromAPI();
      } catch (error) {
        console.log(error);
      }
    },

    async getArtistsFromAPI(isScroll = false){
      try{
        this.isLoading = true;
        const data = await requester.Get(`/get-artistas/${this.artistsPage}/?name=${this.search}&sortBy=${this.sortBy}&sortingOrder=${this.sortingOrder}`, true);
        if (data.status === 200) {
          if(!isScroll){
            this.artists = data.data.artistas;
          }
          else{
            this.artists = this.artists.concat(data.data.artistas);
          }
          if(data.data.artistas.length > 0){
            this.artistsPage++;
            this.continueLoading = true;
          }
          else{
            this.continueLoading = false;
          }
        }
      }
      catch (e){
        console.log(e);
      }
      finally {
        this.isLoading = false;
      }
    },

    createArtist(){
      const data = {
        localId: "localId"+this.localId,
        name: "Nuevo Artista",
        rate: 1,
        active: false,
        description: '',
        image: null,
      }
      this.artists.splice(0, 0, data);
      this.localId++;
    },

    async saveArtist(index){
      if(index >= 0 && index < this.artists.length){
        console.log("guardar: ", index);

        const res = await requester.Put('/save-artista', true, this.artists[index]);
        console.log("saving", res);
        if(res.status == 200){
          this.artists[index] = res.data;
          console.log("guardado exitosamente");
        }
      }                  
    },

    async deleteArtist(index){
      if(index >= 0 && index < this.artists.length){
        const res = await requester.Delete('/delete-artista/'+this.artists[index].id, true);
        console.log("deleting", res);
        if(res.status == 200){
          this.artists.splice(index, 1);
          console.log("borrado exitosamente");
        }
      }                  
    },

    checkFile(index){
      let reader = new FileReader();
      reader.readAsDataURL(this.newImg)
      const me = this;
      reader.onload = function() {
        me.artists[index].image = reader.result;
      };
    },

    findIndex(id){
      if(!id.includes("localId")){
        return this.artists.findIndex((el) => el.id == id);
      }else{
        return this.artists.findIndex((el) => el.localId == id);
      }
    }

  },

  created() {
    this.search = this.$route.query.q ?? "";
    this.onEnter();
  },

}

</script>

<style lang="scss" src="./artists.scss" scoped></style>
